import { __assign, __awaiter, __generator, __rest, __spreadArray } from "tslib";
import { PRICING_PLAN_APP_DEF_ID, RTL_LANGUAGES, PRICING_PLAN_SECTION_ID, BOOKINGS_APP_DEF_ID, BOOKINGS_CHECKOUT_SECTION_ID, BOOKINGS_LIST_SECTION_ID, BOOKINGS_SCHEDULER_SECTION_ID, BOOKINGS_SERVICE_PAGE_SECTION_ID, BOOKINGS_CALENDAR_SECTION_ID, SANTA_MEMBERS_APP_ID, MEMBERS_AREA_SECTION_ID, BOOKINGS_FORM_SECTION_ID, ECOM_APP_DEF_ID, ECOM_CART_SECTION_ID, BOOKINGS_MEMBERS_AREA_WIDGET_ID, } from './bookings.const';
import { ReservedLocationIds, } from '@wix/bookings-uou-types';
import { bulkCreateAnywhereUrl } from '@wix/wix-anywhere-api';
import { getPricingPlansPublicAPI } from '@wix/pricing-plans-tpa-api';
import { experimentsSpecMap } from './experimentsSpecMap';
import { BookingsQueryParams, Referrals, ReservedSlug } from './types';
import { mapBasketToCalendarSelections, storeCalendarSelections, } from '@wix/bookings-catalog-calendar-viewer-utils';
export var DEFAULT_MODAL_DIMENSIONS = { height: 380, width: 580 };
export var PREVIEW_MODAL_DIMENSIONS = { height: 600, width: 600 };
var WixOOISDKAdapter = /** @class */ (function () {
    function WixOOISDKAdapter(wixCodeApi, platformAPIs, appParams, compId, experiments) {
        var _this = this;
        this.wixCodeApi = wixCodeApi;
        this.platformAPIs = platformAPIs;
        this.appParams = appParams;
        this.compId = compId;
        this.experiments = experiments;
        this.navigateToMembersArea = function () { return __awaiter(_this, void 0, void 0, function () {
            var navigateToSection;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMembersAreaAPI()];
                    case 1:
                        navigateToSection = (_a.sent()).navigateToSection;
                        return [4 /*yield*/, navigateToSection({
                                appDefinitionId: BOOKINGS_APP_DEF_ID,
                                sectionId: MEMBERS_AREA_SECTION_ID,
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.setRobotsNoIndex = function () {
            var _a, _b;
            var METATAG_NAME_ROBOTS = 'robots';
            var METATAG_CONTENT_NOINDEX = 'noindex';
            var metaTags = _this.wixCodeApi.seo.metaTags || [];
            var robotsIndex = metaTags.findIndex(function (tag) { return (tag === null || tag === void 0 ? void 0 : tag.name) === METATAG_NAME_ROBOTS; });
            if (robotsIndex > -1) {
                metaTags[robotsIndex].content = METATAG_CONTENT_NOINDEX;
            }
            else {
                // @ts-expect-error
                metaTags.push({
                    name: METATAG_NAME_ROBOTS,
                    content: METATAG_CONTENT_NOINDEX,
                });
            }
            (_b = (_a = _this.wixCodeApi.seo).setMetaTags) === null || _b === void 0 ? void 0 : _b.call(_a, metaTags);
        };
        this.sessionInstanceKey = "".concat(compId, "_instance");
        this.currentLanguage = this.getCurrentLanguageFromPlatform();
    }
    WixOOISDKAdapter.prototype.openWaitingListModal = function (serviceType) {
        return __awaiter(this, void 0, void 0, function () {
            var modalType;
            return __generator(this, function (_a) {
                modalType = 'waitlist';
                return [2 /*return*/, this.openModal(modalType, serviceType, DEFAULT_MODAL_DIMENSIONS)];
            });
        });
    };
    WixOOISDKAdapter.prototype.openUoUPremiumModal = function (serviceType, referralInfo, isDayful) {
        return __awaiter(this, void 0, void 0, function () {
            var modalType;
            return __generator(this, function (_a) {
                modalType = 'uou_not_bookable_modal';
                return [2 /*return*/, this.openModal(modalType, serviceType, DEFAULT_MODAL_DIMENSIONS, referralInfo, isDayful)];
            });
        });
    };
    WixOOISDKAdapter.prototype.openPreviewPremiumModal = function (serviceType, referralInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var modalType;
            return __generator(this, function (_a) {
                modalType = 'preview_premium';
                return [2 /*return*/, this.openModal(modalType, serviceType, PREVIEW_MODAL_DIMENSIONS, referralInfo)];
            });
        });
    };
    WixOOISDKAdapter.prototype.openEcomCheckoutPreviewModal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modalUrl;
            return __generator(this, function (_a) {
                modalUrl = "https://ecom.wix.com/storefront/cartModal?instance=".concat(this.getInstanceForEcom(), "&modal=notInLiveSite");
                return [2 /*return*/, this.wixCodeApi.window.openModal(modalUrl, __assign(__assign({}, PREVIEW_MODAL_DIMENSIONS), { theme: 'BARE' }))];
            });
        });
    };
    WixOOISDKAdapter.prototype.openEcomCheckoutTemplateModal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modalUrl;
            return __generator(this, function (_a) {
                modalUrl = "https://ecom.wix.com/storefront/cartModal?instance=".concat(this.getInstanceForEcom(), "&modal=noOnlinePayments");
                return [2 /*return*/, this.wixCodeApi.window.openModal(modalUrl, __assign(__assign({}, PREVIEW_MODAL_DIMENSIONS), { theme: 'BARE' }))];
            });
        });
    };
    WixOOISDKAdapter.prototype.openModal = function (modalType, serviceType, dimensions, referralInfo, isDayful) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, modalUrl, referralInfoParam;
            return __generator(this, function (_a) {
                baseUrl = 'https://bookings.wixapps.net/_api/bookings-viewer';
                modalUrl = "".concat(baseUrl, "/viewer-modals");
                referralInfoParam = referralInfo
                    ? "&referralInfo=".concat(referralInfo)
                    : "";
                return [2 /*return*/, this.wixCodeApi.window.openModal("".concat(modalUrl, "?deviceType=").concat(this.getDeviceType(), "&instance=").concat(this.getInstance(), "&locale=").concat(this.wixCodeApi.site.language, "&modal=").concat(modalType, "&serviceType=").concat(serviceType).concat(referralInfoParam).concat(isDayful ? '&dayful=sch' : ''), __assign(__assign({}, dimensions), { theme: 'BARE' }))];
            });
        });
    };
    WixOOISDKAdapter.prototype.getCurrentUser = function () {
        return this.wixCodeApi.user.currentUser;
    };
    WixOOISDKAdapter.prototype.promptUserLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.wixCodeApi.user.promptLogin({
                        mode: 'login',
                        lang: this.currentLanguage,
                    })];
            });
        });
    };
    WixOOISDKAdapter.prototype.onUserLogin = function (callback) {
        this.wixCodeApi.user.onLogin(callback);
    };
    WixOOISDKAdapter.prototype.isPricingPlanInstalled = function () {
        if (this.wixCodeApi.site) {
            if (this.wixCodeApi.site.isAppSectionInstalled) {
                return Promise.resolve(this.wixCodeApi.site.isAppSectionInstalled({
                    appDefinitionId: PRICING_PLAN_APP_DEF_ID,
                    sectionId: PRICING_PLAN_SECTION_ID,
                }));
            }
            // TODO: remove when wixCodeApi.site.getAppToken is added to viewerWrapper
            if (this.wixCodeApi.site.getAppToken) {
                return Promise.resolve(!!this.wixCodeApi.site.getAppToken(PRICING_PLAN_APP_DEF_ID));
            }
        }
        return this.isPricingPlanInstalledLegacyMode();
    };
    WixOOISDKAdapter.prototype.navigateAfterAddToCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var continueShoppingUrl, link;
            return __generator(this, function (_a) {
                continueShoppingUrl = this.getUrlQueryParamValue(BookingsQueryParams.CONTINUE_SHOPPING_URL);
                if (!continueShoppingUrl) {
                    return [2 /*return*/, this.navigateToEcomCart()];
                }
                continueShoppingUrl = decodeURIComponent(continueShoppingUrl);
                link = new URL(continueShoppingUrl, this.wixCodeApi.location.baseUrl);
                link.searchParams.append(BookingsQueryParams.REFERRAL, Referrals.BOOKINGS_FORM_WIDGET_WITH_CART);
                this.wixCodeApi.location.to("".concat(link.pathname, "?").concat(link.searchParams.toString()));
                return [2 /*return*/];
            });
        });
    };
    WixOOISDKAdapter.prototype.isPricingPlanInstalledLegacyMode = function () {
        return new Promise(function (resolve) {
            if (window.Wix.Utils.getViewMode() !== 'standalone') {
                window.Wix.isAppSectionInstalled(PRICING_PLAN_SECTION_ID, { appDefinitionId: PRICING_PLAN_APP_DEF_ID }, function (isInstalled) {
                    resolve(isInstalled);
                });
            }
            else {
                resolve(false);
            }
        });
    };
    WixOOISDKAdapter.prototype.getPricingPlansApi = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.pricingPlansApi) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, getPricingPlansPublicAPI(this.wixCodeApi)];
                    case 1:
                        _a.pricingPlansApi = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.pricingPlansApi];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.getPricingPlanUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fullPricingPlanUrl, baseUrl, urlParts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wixCodeApi.site.getSectionUrl({
                            sectionId: PRICING_PLAN_SECTION_ID,
                            appDefinitionId: PRICING_PLAN_APP_DEF_ID,
                        })];
                    case 1:
                        fullPricingPlanUrl = (_a.sent()).url;
                        baseUrl = this.wixCodeApi.location.baseUrl;
                        if (baseUrl) {
                            urlParts = fullPricingPlanUrl.split(baseUrl);
                            return [2 /*return*/, urlParts.length > 1 ? urlParts[1] : fullPricingPlanUrl];
                        }
                        return [2 /*return*/, fullPricingPlanUrl];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToPricingPlanPreview = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var api;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPricingPlansApi()];
                    case 1:
                        api = _a.sent();
                        return [2 /*return*/, api.navigateToPackagePicker(params)];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToPricingPlan = function (_a) {
        var redirectTo = _a.redirectTo, planIds = _a.planIds, maxStartDate = _a.maxStartDate, queryParams = _a.queryParams, title = _a.title, subtitle = _a.subtitle;
        return __awaiter(this, void 0, void 0, function () {
            var api;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getPricingPlansApi()];
                    case 1:
                        api = _b.sent();
                        return [2 /*return*/, api.navigateToPackagePicker({
                                planIds: planIds,
                                title: title,
                                subtitle: subtitle,
                                checkout: {
                                    maxStartDate: maxStartDate,
                                    successStatus: {
                                        navigation: {
                                            type: 'section',
                                            options: {
                                                appDefinitionId: BOOKINGS_APP_DEF_ID,
                                                sectionId: redirectTo.sectionId,
                                                state: redirectTo.relativePath,
                                                queryParams: queryParams,
                                            },
                                        },
                                    },
                                },
                            })];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.isPreviewMode = function () {
        return this.getViewMode() === 'preview';
    };
    WixOOISDKAdapter.prototype.isEditorMode = function () {
        return this.getViewMode() === 'editor';
    };
    WixOOISDKAdapter.prototype.isSiteMode = function () {
        return this.getViewMode() === 'site';
    };
    WixOOISDKAdapter.prototype.isDemoMode = function () {
        var _a;
        return !!((_a = this.getDecodedInstance()) === null || _a === void 0 ? void 0 : _a.demoMode);
    };
    WixOOISDKAdapter.prototype.isTemplateMode = function () {
        return this.getDecodedInstance().siteIsTemplate;
    };
    WixOOISDKAdapter.prototype.setContainerDimensions = function (newWidth, newHeight) {
        if (this.isRunningInIframe() && this.isEditorMode()) {
            window.Wix.resizeComponent({
                width: newWidth,
                height: newHeight,
            });
        }
    };
    WixOOISDKAdapter.prototype.setContainerHeight = function (newHeight) {
        if (this.isRunningInIframe()) {
            window.Wix.setHeight(newHeight);
        }
    };
    WixOOISDKAdapter.prototype.getExternalId = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.isRunningInIframe()) {
                window.Wix.getExternalId(function (externalId) { return resolve(externalId); });
            }
            else {
                reject('should not be called in OOI mode');
            }
        });
    };
    WixOOISDKAdapter.prototype.getViewMode = function () {
        return this.wixCodeApi.window.viewMode.toLowerCase();
    };
    WixOOISDKAdapter.prototype.getCurrentLanguage = function () {
        return this.currentLanguage;
    };
    WixOOISDKAdapter.prototype.getRegionalSettings = function () {
        return this.wixCodeApi.site.regionalSettings;
    };
    WixOOISDKAdapter.prototype.setCurrentLanguage = function (locale) {
        this.currentLanguage = this.getCurrentLanguageFromLocale(locale);
    };
    WixOOISDKAdapter.prototype.getCurrentLanguageFromPlatform = function () {
        return this.getCurrentLanguageFromLocale(this.wixCodeApi.site.language);
    };
    WixOOISDKAdapter.prototype.getCurrentLanguageFromLocale = function (locale) {
        var localeToSubstring = locale ? locale.substring(0, 2) : undefined;
        return localeToSubstring || 'en';
    };
    WixOOISDKAdapter.prototype.isRunningInIframe = function () {
        return !(typeof WorkerGlobalScope !== 'undefined' &&
            self instanceof WorkerGlobalScope);
    };
    WixOOISDKAdapter.prototype.getVisitorId = function () {
        return this.platformAPIs.bi.visitorId;
    };
    WixOOISDKAdapter.prototype.getMetaSiteId = function () {
        return this.platformAPIs.bi.metaSiteId;
    };
    WixOOISDKAdapter.prototype.getOwnerId = function () {
        return this.platformAPIs.bi.ownerId;
    };
    WixOOISDKAdapter.prototype.getMemberId = function () {
        return this.wixCodeApi.user.currentUser.id;
    };
    WixOOISDKAdapter.prototype.getBiToken = function () {
        return this.platformAPIs.bi.biToken;
    };
    WixOOISDKAdapter.prototype.getInstanceId = function () {
        return this.appParams.instanceId;
    };
    WixOOISDKAdapter.prototype.getInstance = function () {
        return (this.wixCodeApi.site.getAppToken(BOOKINGS_APP_DEF_ID) ||
            this.appParams.instance);
    };
    WixOOISDKAdapter.prototype.getInstanceForEcom = function () {
        return this.wixCodeApi.site.getAppToken(ECOM_APP_DEF_ID);
    };
    WixOOISDKAdapter.prototype.getAppDefId = function () {
        return this.appParams.appDefinitionId;
    };
    WixOOISDKAdapter.prototype.getStaticsBaseUrl = function () {
        return this.appParams.baseUrls && this.appParams.baseUrls.staticsBaseUrl;
    };
    WixOOISDKAdapter.prototype.getPlatformAPIs = function () {
        return this.platformAPIs;
    };
    WixOOISDKAdapter.prototype.getMembersAreaAPI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var api;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.membersAreaApi) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.wixCodeApi.site.getPublicAPI(SANTA_MEMBERS_APP_ID)];
                    case 1:
                        api = _a.sent();
                        this.membersAreaApi = api;
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.membersAreaApi];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.getServiceListStaticsBaseUrl = function () {
        return (this.appParams.baseUrls &&
            this.appParams.baseUrls.serviceListStaticsBaseUrl);
    };
    WixOOISDKAdapter.prototype.getPlatformAppStaticsBaseUrl = function () {
        return (this.appParams.baseUrls && this.appParams.baseUrls.platformAppsBaseUrl);
    };
    WixOOISDKAdapter.prototype.getServerBaseUrl = function () {
        return this.isSSR() && this.appParams.baseUrls
            ? this.appParams.baseUrls.serverBaseUrl
            : '/';
    };
    WixOOISDKAdapter.prototype.isOwner = function () {
        return (this.getOwnerId() === this.getVisitorId() ||
            this.getOwnerId() === this.getMemberId());
    };
    WixOOISDKAdapter.prototype.trackEvent = function (evid, payload) {
        this.wixCodeApi.window.trackEvent(evid, payload);
    };
    WixOOISDKAdapter.prototype.trackAnalytics = function (_a) {
        var eventId = _a.eventId, payload = _a.payload;
        try {
            if (!this.isEditorMode()) {
                this.trackEvent(eventId, payload);
            }
        }
        catch (e) {
            console.log(e);
        }
    };
    WixOOISDKAdapter.prototype.getSiteRevision = function () {
        return this.wixCodeApi.site.revision;
    };
    WixOOISDKAdapter.prototype.getSiteTimezone = function () {
        return this.wixCodeApi.site.timezone;
    };
    WixOOISDKAdapter.prototype.getInstanceValue = function (key) {
        var decodedInstance = this.getDecodedInstance();
        if (decodedInstance) {
            return decodedInstance[key] || null;
        }
        return null;
    };
    WixOOISDKAdapter.prototype.getDeviceType = function () {
        return this.wixCodeApi.window.formFactor;
    };
    WixOOISDKAdapter.prototype.getBookingsRelativeUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isBookingCheckoutInstalled, fullBookingsUrl, baseUrl, urlParts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isBookCheckoutInstalled()];
                    case 1:
                        isBookingCheckoutInstalled = _a.sent();
                        return [4 /*yield*/, this.wixCodeApi.site.getSectionUrl({
                                sectionId: isBookingCheckoutInstalled
                                    ? BOOKINGS_CHECKOUT_SECTION_ID
                                    : BOOKINGS_SCHEDULER_SECTION_ID,
                                appDefinitionId: BOOKINGS_APP_DEF_ID,
                            })];
                    case 2:
                        fullBookingsUrl = (_a.sent()).url;
                        baseUrl = this.wixCodeApi.location.baseUrl;
                        if (baseUrl) {
                            urlParts = fullBookingsUrl.split(baseUrl);
                            return [2 /*return*/, urlParts.length > 1 ? urlParts[1] : fullBookingsUrl];
                        }
                        return [2 /*return*/, fullBookingsUrl];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.getServicePageRelativeUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isServicePageInstalled;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isServicePageInstalled()];
                    case 1:
                        isServicePageInstalled = _a.sent();
                        if (isServicePageInstalled) {
                            return [2 /*return*/, this.getSectionRelativeUrl(BOOKINGS_SERVICE_PAGE_SECTION_ID)];
                        }
                        return [2 /*return*/, this.getBookingsRelativeUrl()];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.getBookingCalendarRelativeUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isBookingCalendarInstalled;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isBookingCalendarInstalled()];
                    case 1:
                        isBookingCalendarInstalled = _a.sent();
                        if (isBookingCalendarInstalled) {
                            return [2 /*return*/, this.getSectionRelativeUrl(BOOKINGS_CALENDAR_SECTION_ID)];
                        }
                        return [2 /*return*/, this.getBookingsRelativeUrl()];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.getSectionAbsoluteUrl = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        baseUrl = this.wixCodeApi.location.baseUrl;
                        _a = baseUrl;
                        return [4 /*yield*/, this.getSectionRelativeUrl(BOOKINGS_FORM_SECTION_ID)];
                    case 1: return [2 /*return*/, (_a + (_b.sent()))];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.getSectionRelativeUrl = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, fullBookingsUrl, prefix, baseUrl, urlParts;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.wixCodeApi.site.getSectionUrl({
                            sectionId: sectionId,
                            appDefinitionId: BOOKINGS_APP_DEF_ID,
                        })];
                    case 1:
                        _a = _b.sent(), fullBookingsUrl = _a.url, prefix = _a.prefix;
                        if (prefix) {
                            return [2 /*return*/, "/".concat(prefix)];
                        }
                        baseUrl = this.wixCodeApi.location.baseUrl;
                        if (baseUrl) {
                            urlParts = fullBookingsUrl.split(baseUrl);
                            return [2 /*return*/, urlParts.length > 1 ? urlParts[1] : fullBookingsUrl];
                        }
                        return [2 /*return*/, fullBookingsUrl];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToServiceList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var bookOnlineRelativeUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBookOnlineRelativeUrl()];
                    case 1:
                        bookOnlineRelativeUrl = _a.sent();
                        this.wixCodeApi.location.to(bookOnlineRelativeUrl);
                        return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToBookingsWithSuffix = function (suffix) {
        if (suffix === void 0) { suffix = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var bookingsRelativeUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBookingsRelativeUrl()];
                    case 1:
                        bookingsRelativeUrl = _a.sent();
                        this.wixCodeApi.location.to(bookingsRelativeUrl + suffix);
                        return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToBookingsServicePage = function (serviceSlug, _a) {
        var _b = _a === void 0 ? {} : _a, referral = _b.referral, location = _b.location;
        return __awaiter(this, void 0, void 0, function () {
            var suffix, query, servicePageRelativeUrl;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        suffix = "".concat(serviceSlug);
                        query = this.queryBuilder({ referral: referral, location: location });
                        return [4 /*yield*/, this.getServicePageRelativeUrl()];
                    case 1:
                        servicePageRelativeUrl = _c.sent();
                        this.wixCodeApi.location.to("".concat(servicePageRelativeUrl, "/").concat(suffix + query));
                        return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToBookingsCalendarPageWithBasket = function (basket, navigationContext) {
        if (navigationContext === void 0) { navigationContext = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var calendarSelections;
            return __generator(this, function (_a) {
                calendarSelections = mapBasketToCalendarSelections(basket);
                storeCalendarSelections({
                    calendarSelections: calendarSelections,
                    session: this.platformAPIs.storage.session,
                });
                return [2 /*return*/, this.navigateToBookingsBookAction(true, ReservedSlug.CALENDAR_COMPLEX_NAVIGATION, {
                        referral: navigationContext.referral,
                        timezone: navigationContext.timezone,
                    }, false)];
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToBookingsCalendarPage = function (serviceSlugOrBasket, navigationContext) {
        if (navigationContext === void 0) { navigationContext = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (typeof serviceSlugOrBasket === 'string' ||
                    serviceSlugOrBasket instanceof String) {
                    return [2 /*return*/, this.navigateToBookingsBookAction(true, serviceSlugOrBasket, navigationContext)];
                }
                else {
                    return [2 /*return*/, this.navigateToBookingsCalendarPageWithBasket(serviceSlugOrBasket, navigationContext)];
                }
                return [2 /*return*/];
            });
        });
    };
    WixOOISDKAdapter.prototype.removeUndefinedKeys = function (obj) {
        return Object.fromEntries(Object.entries(obj).filter(function (_a) {
            var _ = _a[0], v = _a[1];
            return v !== undefined;
        }));
    };
    WixOOISDKAdapter.prototype.navigateToBookingsBookAction = function (isSlotSelectionNeeded, serviceSlug, _a, copyCurrentQueryParams) {
        if (_a === void 0) { _a = {}; }
        var referral = _a.referral, staff = _a.staff, location = _a.location, timezone = _a.timezone, resource = _a.resource, queryParams = __rest(_a, ["referral", "staff", "location", "timezone", "resource"]);
        if (copyCurrentQueryParams === void 0) { copyCurrentQueryParams = true; }
        return __awaiter(this, void 0, void 0, function () {
            var suffix, query, _b, bookingCalendarRelativeUrl;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        suffix = '';
                        query = '';
                        if (!serviceSlug) return [3 /*break*/, 3];
                        _b = isSlotSelectionNeeded;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.isBookingCalendarInstalled()];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        suffix =
                            _b ? "/".concat(serviceSlug)
                                : "/".concat(serviceSlug, "/book");
                        query = this.queryBuilder(__assign({ referral: referral, staff: staff, location: location, timezone: timezone, resource: resource }, queryParams), copyCurrentQueryParams);
                        return [3 /*break*/, 4];
                    case 3:
                        query = this.queryBuilder({
                            referral: referral,
                            resource: resource,
                        }, copyCurrentQueryParams);
                        _c.label = 4;
                    case 4: return [4 /*yield*/, (isSlotSelectionNeeded
                            ? this.getBookingCalendarRelativeUrl()
                            : this.getBookingsRelativeUrl())];
                    case 5:
                        bookingCalendarRelativeUrl = _c.sent();
                        this.wixCodeApi.location.to("".concat(bookingCalendarRelativeUrl).concat(suffix + query));
                        return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.queryBuilder = function (queryParams, copyCurrentQueryParams) {
        if (copyCurrentQueryParams === void 0) { copyCurrentQueryParams = true; }
        var currentParams = copyCurrentQueryParams
            ? this.getUrlQueryParams()
            : {};
        var params = [];
        for (var _i = 0, _a = Object.entries(__assign(__assign({}, currentParams), this.removeUndefinedKeys(queryParams))); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (value) {
                params.push(["".concat(key, "=").concat(value)]);
            }
        }
        return params.length ? "?".concat(params.join('&')) : '';
    };
    WixOOISDKAdapter.prototype.getAnywhereEmbedIdQueryParam = function (_a) {
        var _b = _a.isAnywhereSpecEnable, isAnywhereSpecEnable = _b === void 0 ? false : _b;
        return isAnywhereSpecEnable
            ? this.getUrlQueryParamValue('anywhereEmbedId')
            : undefined;
    };
    WixOOISDKAdapter.prototype.buildAnywhereViewerlessMessage = function (anywhereEmbedId, url) {
        return "".concat(anywhereEmbedId, "::viewerless::").concat(JSON.stringify({
            $type: 'external-route',
            $eventData: {
                url: url,
                navigationType: 'page',
            },
            $to: 'embed',
            $frameId: anywhereEmbedId,
        }));
    };
    WixOOISDKAdapter.prototype.navigateToBookingsFormPage = function (_a) {
        var _b, _c;
        var slotAvailability = _a.slotAvailability, serviceId = _a.serviceId, serviceSlug = _a.serviceSlug, dynamicPriceInfo = _a.dynamicPriceInfo, isAnywhereSpecEnable = _a.isAnywhereSpecEnable, ecom = _a.ecom, _d = _a.queryParams, queryParams = _d === void 0 ? {} : _d;
        return __awaiter(this, void 0, void 0, function () {
            var timezone, referral, continueShoppingUrl, formUrl, anywhereEmbedId, _e, _f, _g, _h, sessionDetails;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        timezone = queryParams.timezone, referral = queryParams.referral, continueShoppingUrl = queryParams.continueShoppingUrl;
                        return [4 /*yield*/, this.isBookingFormInstalled()];
                    case 1:
                        if (!_j.sent()) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getSectionRelativeUrl(BOOKINGS_FORM_SECTION_ID)];
                    case 2:
                        formUrl = _j.sent();
                        this.removeFromSessionStorage(BookingsQueryParams.AVAILABILITY_SLOT);
                        this.removeFromSessionStorage(BookingsQueryParams.SERVICE_ID);
                        this.removeFromSessionStorage(BookingsQueryParams.TIMEZONE);
                        this.removeFromSessionStorage(BookingsQueryParams.DYNAMIC_PRICING);
                        this.removeFromSessionStorage(BookingsQueryParams.ECOM);
                        slotAvailability &&
                            this.setToSessionStorage(BookingsQueryParams.AVAILABILITY_SLOT, JSON.stringify(slotAvailability));
                        serviceId &&
                            this.setToSessionStorage(BookingsQueryParams.SERVICE_ID, JSON.stringify(serviceId));
                        timezone &&
                            this.setToSessionStorage(BookingsQueryParams.TIMEZONE, JSON.stringify(timezone));
                        dynamicPriceInfo &&
                            this.setToSessionStorage(BookingsQueryParams.DYNAMIC_PRICING, JSON.stringify(this.convertDynamicPriceToMultiDynamicPrice(dynamicPriceInfo, slotAvailability)));
                        ecom &&
                            this.setToSessionStorage(BookingsQueryParams.ECOM, JSON.stringify(ecom));
                        anywhereEmbedId = this.getAnywhereEmbedIdQueryParam({
                            isAnywhereSpecEnable: isAnywhereSpecEnable,
                        });
                        if (!(anywhereEmbedId && !this.isPreviewMode())) return [3 /*break*/, 4];
                        _f = (_e = this.wixCodeApi.window).postMessage;
                        _g = this.buildAnywhereViewerlessMessage;
                        _h = [anywhereEmbedId];
                        return [4 /*yield*/, bulkCreateAnywhereUrl({
                                urls: [
                                    "".concat(formUrl).concat(this.queryBuilder({
                                        referral: referral,
                                    })),
                                ],
                                baseUrl: this.wixCodeApi.location.baseUrl,
                            })];
                    case 3: 
                    // @ts-expect-error
                    return [2 /*return*/, _f.apply(_e, [_g.apply(this, _h.concat([(_j.sent())[0]]))])];
                    case 4: return [2 /*return*/, this.wixCodeApi.location.to("".concat(formUrl).concat(this.queryBuilder({ referral: referral, continueShoppingUrl: continueShoppingUrl })))];
                    case 5:
                        if (slotAvailability) {
                            sessionDetails = {
                                id: slotAvailability.slot.sessionId,
                                slug: serviceSlug,
                                scheduleId: slotAvailability.slot.scheduleId,
                                start: new Date(slotAvailability.slot.startDate).valueOf(),
                                end: new Date(slotAvailability.slot.endDate).valueOf(),
                                staffMemberId: (_b = slotAvailability.slot.resource) === null || _b === void 0 ? void 0 : _b.id,
                                locationId: (_c = slotAvailability.slot.location) === null || _c === void 0 ? void 0 : _c.id,
                            };
                            return [2 /*return*/, this.navigateToBookingsContactInfoPage(sessionDetails, referral, timezone)];
                        }
                        else {
                            return [2 /*return*/, this.navigateToCourseContactInfoPage(serviceSlug, referral, timezone)];
                        }
                        _j.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.convertDynamicPriceToMultiDynamicPrice = function (dynamicPriceInfo, slotAvailability) {
        var _a, _b;
        if (Array.isArray(dynamicPriceInfo)) {
            return dynamicPriceInfo;
        }
        return [
            {
                dynamicPriceInfo: dynamicPriceInfo,
                serviceId: (_a = slotAvailability === null || slotAvailability === void 0 ? void 0 : slotAvailability.slot) === null || _a === void 0 ? void 0 : _a.serviceId,
                startDate: (_b = slotAvailability === null || slotAvailability === void 0 ? void 0 : slotAvailability.slot) === null || _b === void 0 ? void 0 : _b.startDate,
            },
        ];
    };
    WixOOISDKAdapter.prototype.navigateToCourseContactInfoPage = function (serviceSlug, referral, timezone) {
        return __awaiter(this, void 0, void 0, function () {
            var suffix, queryParams;
            return __generator(this, function (_a) {
                suffix = "/".concat(serviceSlug, "/book");
                queryParams = {
                    referral: referral,
                    timezone: timezone,
                };
                return [2 /*return*/, this.navigateToBookingsWithSuffix("".concat(suffix).concat(this.queryBuilder(queryParams)))];
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToBookingsContactInfoPage = function (sessionDetails, referral, timezone) {
        return __awaiter(this, void 0, void 0, function () {
            var suffix, queryParams, locationSuffix, sessionIdSuffix;
            return __generator(this, function (_a) {
                suffix = "/".concat(sessionDetails.slug, "/book/").concat(sessionDetails.scheduleId, "/").concat(sessionDetails.start, "/").concat(sessionDetails.end, "/").concat(sessionDetails.staffMemberId);
                queryParams = __assign(__assign({}, (sessionDetails ? { referral: referral } : {})), { timezone: timezone });
                locationSuffix = sessionDetails.locationId
                    ? "/".concat(sessionDetails.locationId)
                    : "/".concat(ReservedLocationIds.UNSPECIFIED_LOCATION);
                sessionIdSuffix = sessionDetails.id ? "/".concat(sessionDetails.id) : '';
                return [2 /*return*/, this.navigateToBookingsWithSuffix("".concat(suffix).concat(locationSuffix).concat(sessionIdSuffix).concat(this.queryBuilder(queryParams)))];
            });
        });
    };
    WixOOISDKAdapter.prototype.encodeUTF8ToUrlSafeBase64 = function (str) {
        return btoa(unescape(encodeURIComponent(str))).replace(/\//g, '-');
    };
    WixOOISDKAdapter.prototype.navigateToBookingsCheckout = function (bookedEntity, referral, timezone) {
        return __awaiter(this, void 0, void 0, function () {
            var encodedBooking, suffix, queryParams;
            return __generator(this, function (_a) {
                encodedBooking = this.encodeUTF8ToUrlSafeBase64(JSON.stringify(bookedEntity));
                suffix = "/checkout/".concat(encodedBooking);
                queryParams = {
                    referral: referral,
                    timezone: timezone,
                };
                return [2 /*return*/, this.navigateToBookingsWithSuffix("".concat(suffix).concat(this.queryBuilder(queryParams)))];
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToBookingsSessionPage = function (session, referral) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var locationId, slotDetails;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        locationId = ((_a = session.location) === null || _a === void 0 ? void 0 : _a.businessLocation)
                            ? "".concat(session.location.businessLocation.id)
                            : '';
                        slotDetails = {
                            id: session.id,
                            slug: session.service.slugs[0],
                            scheduleId: session.bookingInfo.scheduleId,
                            start: session.bookingInfo.start,
                            end: session.bookingInfo.end,
                            staffMemberId: session.staffMember.id,
                            locationId: locationId,
                        };
                        return [4 /*yield*/, this.navigateToBookingsContactInfoPage(slotDetails, referral)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.isSSR = function () {
        return this.wixCodeApi.window.rendering.env === 'backend';
    };
    WixOOISDKAdapter.prototype.isSEO = function () {
        return this.wixCodeApi.seo.isInSEO();
    };
    WixOOISDKAdapter.prototype.getCompId = function () {
        return this.compId;
    };
    WixOOISDKAdapter.prototype.isSessionInstanceSet = function () {
        return (this.platformAPIs.storage.session.getItem(this.sessionInstanceKey) ===
            this.getInstance());
    };
    WixOOISDKAdapter.prototype.setSessionInstance = function () {
        this.platformAPIs.storage.session.setItem(this.sessionInstanceKey, this.getInstance());
    };
    WixOOISDKAdapter.prototype.isViewDirectionRtl = function () {
        return RTL_LANGUAGES.indexOf(this.getCurrentLanguage()) > -1;
    };
    WixOOISDKAdapter.prototype.getScale = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.isRunningInIframe()) {
                window.Wix.getBoundingRectAndOffsets(function (_a) {
                    var scale = _a.scale;
                    return resolve(scale);
                });
            }
            else {
                resolve(1);
            }
        });
    };
    WixOOISDKAdapter.prototype.getDecodedInstance = function () {
        var instance = this.getInstance();
        if (!instance) {
            return null;
        }
        var encodedInstance = instance.substring(instance.indexOf('.') + 1);
        return JSON.parse(this.decodeBase64(encodedInstance));
    };
    WixOOISDKAdapter.prototype.decodeBase64 = function (str) {
        if (typeof atob !== 'undefined') {
            return atob(str);
        }
        return '{}';
    };
    WixOOISDKAdapter.prototype.isCartInstalled = function () {
        return this.wixCodeApi.site.isAppSectionInstalled({
            sectionId: ECOM_CART_SECTION_ID,
            appDefinitionId: ECOM_APP_DEF_ID,
        });
    };
    WixOOISDKAdapter.prototype.isBookingsSectionInstalled = function (sectionId) {
        if (this.isRunningInIframe()) {
            return new Promise(function (resolve) {
                window.Wix.isAppSectionInstalled(sectionId, { appDefinitionId: BOOKINGS_APP_DEF_ID }, function (isInstalled) {
                    resolve(isInstalled);
                });
            });
        }
        return Promise.resolve(this.wixCodeApi.site.isAppSectionInstalled({
            sectionId: sectionId,
            appDefinitionId: BOOKINGS_APP_DEF_ID,
        }));
    };
    WixOOISDKAdapter.prototype.isMemberAreaInstalled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isMemberAreaInstalledEnabled, membersPublicAPI;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isMemberAreaInstalledEnabled = this.experiments.enabled(experimentsSpecMap.IS_NEW_BOOKINGS_MEMBERS_AREA_INSTALLED);
                        if (!isMemberAreaInstalledEnabled) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.wixCodeApi.site.getPublicAPI(SANTA_MEMBERS_APP_ID)];
                    case 1:
                        membersPublicAPI = _a.sent();
                        return [4 /*yield*/, membersPublicAPI.getSectionUrl({
                                widgetId: BOOKINGS_MEMBERS_AREA_WIDGET_ID,
                                appDefinitionId: BOOKINGS_APP_DEF_ID,
                                sectionId: MEMBERS_AREA_SECTION_ID,
                            })];
                    case 2: return [2 /*return*/, !!(_a.sent())];
                    case 3: return [2 /*return*/, Promise.resolve(this.wixCodeApi.site.isAppSectionInstalled({
                            sectionId: MEMBERS_AREA_SECTION_ID,
                            appDefinitionId: BOOKINGS_APP_DEF_ID,
                        }))];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.isBookingsOnEcom = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, isFormInstalled, isBookingsCheckoutInstalled;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.isBookingFormInstalled(),
                            this.isBookCheckoutInstalled(),
                        ])];
                    case 1:
                        _a = _b.sent(), isFormInstalled = _a[0], isBookingsCheckoutInstalled = _a[1];
                        return [2 /*return*/, isFormInstalled && !isBookingsCheckoutInstalled];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToEcomCheckoutPage = function (_a) {
        var checkoutId = _a.checkoutId, continueShoppingUrl = _a.continueShoppingUrl;
        return __awaiter(this, void 0, void 0, function () {
            var ecomApi;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.wixCodeApi.site.getPublicAPI(ECOM_APP_DEF_ID)];
                    case 1:
                        ecomApi = _b.sent();
                        return [2 /*return*/, ecomApi.navigate.toCheckout(__assign({ checkoutId: checkoutId }, (continueShoppingUrl ? { continueShoppingUrl: continueShoppingUrl } : {})))];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToEcomThankYouPage = function (_a) {
        var orderId = _a.orderId, continueShoppingUrl = _a.continueShoppingUrl;
        return __awaiter(this, void 0, void 0, function () {
            var ecomApi;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.wixCodeApi.site.getPublicAPI(ECOM_APP_DEF_ID)];
                    case 1:
                        ecomApi = _b.sent();
                        return [2 /*return*/, ecomApi.navigate.toThankYouPage(__assign({ orderId: orderId }, (continueShoppingUrl ? { continueShoppingUrl: continueShoppingUrl } : {})))];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.reloadCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ecomApi;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wixCodeApi.site.getPublicAPI(ECOM_APP_DEF_ID)];
                    case 1:
                        ecomApi = _a.sent();
                        return [4 /*yield*/, ecomApi.cart.reloadCart()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToEcomCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ecomApi;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wixCodeApi.site.getPublicAPI(ECOM_APP_DEF_ID)];
                    case 1:
                        ecomApi = _a.sent();
                        return [2 /*return*/, ecomApi.navigate.toCart()];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.isBookCheckoutInstalled = function () {
        return this.isBookingsSectionInstalled(BOOKINGS_CHECKOUT_SECTION_ID);
    };
    WixOOISDKAdapter.prototype.isBookOnlineInstalled = function () {
        return this.isBookingsSectionInstalled(BOOKINGS_LIST_SECTION_ID);
    };
    WixOOISDKAdapter.prototype.isServicePageInstalled = function () {
        return this.isBookingsSectionInstalled(BOOKINGS_SERVICE_PAGE_SECTION_ID);
    };
    WixOOISDKAdapter.prototype.isBookingCalendarInstalled = function () {
        return this.isBookingsSectionInstalled(BOOKINGS_CALENDAR_SECTION_ID);
    };
    WixOOISDKAdapter.prototype.isBookingFormInstalled = function () {
        return this.isBookingsSectionInstalled(BOOKINGS_FORM_SECTION_ID);
    };
    WixOOISDKAdapter.prototype.isCartEnabled = function (businessInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (businessInfo.isCartEnabled) {
                    return [2 /*return*/, this.isCartInstalled()];
                }
                return [2 /*return*/, false];
            });
        });
    };
    WixOOISDKAdapter.prototype.getCsrfToken = function () {
        return this.platformAPIs.getCsrfToken();
    };
    WixOOISDKAdapter.prototype.getBookingsUrlSuffix = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fullBookingsUrl, fullUrl, urlParts, bookingsSuffix;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wixCodeApi.site.getSectionUrl({
                            sectionId: BOOKINGS_LIST_SECTION_ID,
                            appDefinitionId: BOOKINGS_APP_DEF_ID,
                        })];
                    case 1:
                        fullBookingsUrl = (_a.sent()).url;
                        fullUrl = this.wixCodeApi.location.url;
                        urlParts = fullUrl.split(fullBookingsUrl);
                        bookingsSuffix = urlParts.length > 1 && urlParts[1] ? urlParts[1] : '';
                        return [2 /*return*/, this.isSuffixContainOnlyQueryParam(bookingsSuffix)
                                ? ''
                                : bookingsSuffix];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.getUrlQueryParams = function () {
        return this.wixCodeApi.location.query;
    };
    WixOOISDKAdapter.prototype.getSectionUrlParams = function () {
        try {
            var params = __assign({}, (this.getUrlQueryParams().appSectionParams
                ? JSON.parse(decodeURI(this.getUrlQueryParams().appSectionParams))
                : {}));
            return params;
        }
        catch (_a) {
            return {};
        }
    };
    WixOOISDKAdapter.prototype.getUrlQueryParamValue = function (key) {
        var params = __assign(__assign({}, this.getSectionUrlParams()), this.getUrlQueryParams());
        return params[key];
    };
    WixOOISDKAdapter.prototype.setUrlQueryParam = function (key, value) {
        var _a;
        if (typeof value !== 'undefined') {
            this.wixCodeApi.location.queryParams.add((_a = {}, _a[key] = value, _a));
        }
    };
    WixOOISDKAdapter.prototype.isSuffixContainOnlyQueryParam = function (urlSuffix) {
        var splittedByQueryParam = urlSuffix.split('?');
        return (splittedByQueryParam.length > 1 &&
            !splittedByQueryParam[0] &&
            splittedByQueryParam[1]);
    };
    WixOOISDKAdapter.prototype.navigateToServiceListWithQuery = function (queryName, queryValue) {
        return __awaiter(this, void 0, void 0, function () {
            var bookOnlineRelativeUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBookOnlineRelativeUrl()];
                    case 1:
                        bookOnlineRelativeUrl = _a.sent();
                        this.wixCodeApi.location.to("".concat(bookOnlineRelativeUrl, "?").concat(queryName, "=").concat(queryValue));
                        return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.getBookOnlineRelativeUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var bookOnlineFullUrl, baseUrl, urlParts, bookOnlineRelativeUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBookOnlineFullUrl()];
                    case 1:
                        bookOnlineFullUrl = _a.sent();
                        baseUrl = this.wixCodeApi.location.baseUrl;
                        urlParts = bookOnlineFullUrl.split(baseUrl);
                        bookOnlineRelativeUrl = urlParts.length > 1 ? urlParts[1] : bookOnlineFullUrl;
                        return [2 /*return*/, bookOnlineRelativeUrl];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.getBookOnlineFullUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isBookOnlineInstalled, bookOnlineFullUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isBookOnlineInstalled()];
                    case 1:
                        isBookOnlineInstalled = _a.sent();
                        return [4 /*yield*/, this.wixCodeApi.site.getSectionUrl({
                                sectionId: isBookOnlineInstalled
                                    ? BOOKINGS_LIST_SECTION_ID
                                    : BOOKINGS_SCHEDULER_SECTION_ID,
                                appDefinitionId: BOOKINGS_APP_DEF_ID,
                            })];
                    case 2:
                        bookOnlineFullUrl = (_a.sent()).url;
                        return [2 /*return*/, bookOnlineFullUrl];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToSpecificSitePage = function (pageId) {
        this.wixCodeApi.location.navigateTo({ type: 'PageLink', pageId: pageId });
    };
    WixOOISDKAdapter.prototype.getServiceSlug = function (pageName, isAppReflowServiceSlug) {
        var _a;
        if (isAppReflowServiceSlug === void 0) { isAppReflowServiceSlug = false; }
        return __awaiter(this, void 0, void 0, function () {
            var sitePageName, locationPaths, sitePageNameIndex, isSitePageNameExistInPath, isServiceSlugExistsInPath, serviceSlug, shouldFixProblematicSiteStructureInPreview, siteWithRouterPage;
            return __generator(this, function (_b) {
                sitePageName = (_a = this.wixCodeApi.site.currentPage.url) === null || _a === void 0 ? void 0 : _a.substring(1).toLowerCase();
                locationPaths = this.wixCodeApi.location.path.map(function (subPath) {
                    return subPath.toLowerCase();
                });
                if (!sitePageName &&
                    this.isSiteMode() &&
                    this.wixCodeApi.site.currentPage.type === 'lightbox') {
                    sitePageName = locationPaths[0];
                }
                sitePageNameIndex = locationPaths.indexOf(sitePageName);
                isSitePageNameExistInPath = sitePageNameIndex !== -1;
                if (!isSitePageNameExistInPath && this.isPreviewMode()) {
                    sitePageNameIndex = 1;
                }
                isServiceSlugExistsInPath = isSitePageNameExistInPath &&
                    sitePageNameIndex !== this.wixCodeApi.location.path.length - 1;
                serviceSlug = isServiceSlugExistsInPath
                    ? this.wixCodeApi.location.path[sitePageNameIndex + 1]
                    : '';
                shouldFixProblematicSiteStructureInPreview = this.isPreviewMode() &&
                    !isSitePageNameExistInPath &&
                    this.wixCodeApi.location.path.length === 1 &&
                    locationPaths[0] !== pageName;
                siteWithRouterPage = isAppReflowServiceSlug && this.wixCodeApi.site.currentPage.prefix;
                if (shouldFixProblematicSiteStructureInPreview || siteWithRouterPage) {
                    serviceSlug = this.wixCodeApi.location.path[0];
                }
                if (serviceSlug) {
                    serviceSlug = decodeURI(serviceSlug);
                }
                return [2 /*return*/, serviceSlug];
            });
        });
    };
    WixOOISDKAdapter.prototype.renderSeoTags = function (itemType, itemData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wixCodeApi.seo.renderSEOTags({
                            itemType: itemType,
                            itemData: itemData,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.setToSessionStorage = function (key, value) {
        this.platformAPIs.storage.session.setItem(key, value);
    };
    WixOOISDKAdapter.prototype.getFromSessionStorage = function (key) {
        return this.platformAPIs.storage.session.getItem(key);
    };
    WixOOISDKAdapter.prototype.removeFromSessionStorage = function (key) {
        return this.platformAPIs.storage.session.removeItem(key);
    };
    WixOOISDKAdapter.prototype.getUserRoles = function () {
        return this.wixCodeApi.user.currentUser.getRoles();
    };
    WixOOISDKAdapter.prototype.getCurrentPath = function () {
        var paths = this.wixCodeApi.location.path;
        if (this.wixCodeApi.site.currentPage.prefix) {
            return __spreadArray([this.wixCodeApi.site.currentPage.prefix], paths, true);
        }
        return paths;
    };
    WixOOISDKAdapter.prototype.isBackFromFormWithCart = function () {
        var referral = this.getUrlQueryParamValue(BookingsQueryParams.REFERRAL);
        return referral === Referrals.BOOKINGS_FORM_WIDGET_WITH_CART;
    };
    return WixOOISDKAdapter;
}());
export { WixOOISDKAdapter };
//# sourceMappingURL=WixOOISDKAdapter.js.map